import { useEffect, useState } from "react";
import { BsArrowUp } from "react-icons/bs";
import WorkContent from "../components/work/WorkContent";

const Work = () => {
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 200) {
      setVisible(true);
    } else if (scrolled <= 200) {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  window.addEventListener("scroll", toggleVisible);
  useEffect(() => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 0) {
      scrollToTop();
    }
  }, []);
  return (
    <div>
      <WorkContent />
      <div>
        {visible && (
          <div
            className="cursor-pointer bg-gradient-to-tr from-[#FE4904] to-[#F7164C] fixed bottom-10 right-10 w-[40px] h-[40px] flex items-center justify-center rounded-lg hover:from-[#F7164C] hover:to-[#FE4904]"
            onClick={scrollToTop}
          >
            <BsArrowUp color="white" size="24px" />
          </div>
        )}
      </div>
    </div>
  );
};
export default Work;
